import dayjs from "dayjs";

export const calculateDateRange = (date: string): { fromDate: string; toDate: string } => {
  const fromDate = dayjs(date).startOf("month").subtract(5, "day").format("YYYY-MM-DD");
  const toDate = dayjs(date).endOf("month").add(5, "day").format("YYYY-MM-DD");

  return { fromDate, toDate };
};
